module.exports = __webpack_public_path__ + "static/media/n-publicate.3d8fb947.svg";